import trimStart from 'lodash/trimStart';

export default function WithPrefix(url) {
	const basePath = '';
	return basePath + '/' + trimStart(url, '/');
}
